module.exports = __webpack_public_path__ + "media/images/sales/early/eyecatch-early-02-27a18734b0bf59512dface393575d341.svg";